import React from 'react';
import {HInput} from "../../../validation/HForm";
import {useSelector} from "react-redux";
import './nonCash.scss';

const NonCash = ({erip = true, cash = true, nonCash = true, onFocus = null, onChange = null}) => {
    const {accessFeatures} = useSelector(({user}) => user);

    return (<div className='nonCash-operationBloc'>
        <h3>Внесено:</h3>
        <div className='nonCash-operation'>
            {cash && <div className='nonCash-operationItem'>
                <span className='nonCash-operationItemTitle'>НАЛИЧНЫЕ</span>
                <div className='nonCash-input'>
                    <HInput
                        type="number"
                        className="input"
                        name="deposit.cash"
                        h={true}
                        def
                        step={0.01}
                        onFocus={onFocus}
                        onChange={onChange}
                    />
                </div>
            </div>}
            {nonCash && <div className='nonCash-operationItem'>
                <span className='nonCash-operationItemTitle'>БЕЗНАЛ</span>
                <div className='nonCash-input'>
                    <HInput
                        type="number"
                        className="input"
                        name="deposit.nonCash"
                        h={true}
                        def
                        step={0.01}
                    />
                </div>
            </div>}
            {erip && <div className='nonCash-operationItem'>
                <span className='nonCash-operationItemTitle'>ЕРИП</span>
                <div className='nonCash-input'>
                    <HInput
                        type="number"
                        className="input"
                        name="deposit.bankTransaction"
                        h={true}
                        def
                        step={0.01}
                    />
                </div>
            </div>}
        </div>
    </div>);
};

export default NonCash;